import React, { FunctionComponent } from 'react';
import GamesRequestList from '../GamesRequestList/GamesRequestList';
import { useStore } from 'effector-react';
import modals, { IModalsState } from '@stores/modals';
import { IGameRequest } from '@interfaces/IGameRequest';
import GameRequestModalReject from '@pages/GamesPage/GameRequestModal/GameRequestModalReject';
import GameRequestModalGameExist from '@pages/GamesPage/GameRequestModal/GameRequestModalGameExist';
import { filters, getList } from '@stores/gamesRequest/gamesRequest';
import { Input } from 'antd';
import css from './GamesRequest.module.less';
import useTranslate from '@hooks/useTranslate';
import componentContent from '@pages/GamesPage/GamesPage.module.json';

const GamesRequest: FunctionComponent<unknown> = () => {
  const {
    visibleState: { gameRequest: visible },
    data,
  } = useStore<IModalsState<{ games: IGameRequest[]; type: 'REJECT' | 'GAME_EXIST' }>>(modals);
  const currentFilterParams = useStore(filters);
  const onSearch = (filter: string) => {
    getList({ filters: { ...currentFilterParams, filter } });
  };
  const content = useTranslate(componentContent);

  return (
    <>
      <div className={css.root}>
        <Input.Search placeholder={content.search} onSearch={onSearch} allowClear />
      </div>
      <GamesRequestList />
      {visible ? (
        data.type === 'REJECT' ? (
          <GameRequestModalReject games={data.games} />
        ) : (
          <GameRequestModalGameExist games={data.games} />
        )
      ) : null}
    </>
  );
};

export default GamesRequest;
